import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/vercel/path0/layouts/admin.vue").then(m => m.default || m)),
  client: defineAsyncComponent(() => import("/vercel/path0/layouts/client.vue").then(m => m.default || m)),
  operator: defineAsyncComponent(() => import("/vercel/path0/layouts/operator.vue").then(m => m.default || m)),
  public: defineAsyncComponent(() => import("/vercel/path0/layouts/public.vue").then(m => m.default || m))
}